<div>
    <div class="text-center font-c1 text-white">Raspa aquí <i class="mdi mdi-arrow-down-right text-white"></i></div>
    <div class="scratcher">
        <div style="position: relative;">
            <canvas #scratcherCanvas id="scratcherCanvas" *ngIf="!hideCanvas"></canvas>
            <div *ngIf="isWinner && coupon">
                <div class="m-t-10" style="border: 3px solid #fff; border-radius: 15px;">
                    <div class="text-center font-h5 text-white">¡Ganáste!</div>
                    <div class="text-center font-c1 m-b-10 text-white">{{coupon?.name}}</div>
                    <div class="w-100 m-b-10 d-flex-center">
                        <div class="img-container">
                            <div class="img-bg d-flex-center">
                                <img src="assets/images/GiviBITFormat3.png" style="height: 100%;" >
                                <img  [src]="coupon?.thumbnailUrl" alt="Carga tu foto aquí" class="img-coupon"/>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            <div *ngIf="!isWinner" class="d-flex-center">
                <img src="assets/images/goodlucknext.png" width="280" height="200">
            </div>
        </div>
        <div *ngIf="showClaim && isWinner" class="d-flex-center m-t-20">
            <button class="btn btn-primary btn-wmd" (click)="onClaimGiveaway()">Adquirir</button>
        </div> 
        <div *ngIf="!isWinner && !firstScratch" class="d-flex-center m-t-20">
            <div class="form-control-feedback text-center">
                <a class="text-white font-c1 m-t-20" (click)="onClose()" style="text-decoration: underline;">
                    Cerrar
                </a>
            </div>
        </div> 
    </div>
</div> 